// extracted by mini-css-extract-plugin
export default {"idnow2":"_3FveNOboANvLulInmOw6aw=="};